module.exports = __webpack_public_path__ + "img/east-meets-dress_banner.dfd8d1c1.jpg";